module.exports = __webpack_public_path__ + "img/06_BC7_emulate_kudzu.d5a8055d.jpg";